/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * GeoJSON object containing a polygon. Based on http://geojson.org/
 * @export
 * @interface Polygon
 */
export interface Polygon {
    /**
     * 
     * @type {Array<string>}
     * @memberof Polygon
     */
    extensions?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof Polygon
     */
    coordinates?: object;
    /**
     * 
     * @type {string}
     * @memberof Polygon
     */
    type?: PolygonTypeEnum;
}


/**
 * @export
 */
export const PolygonTypeEnum = {
    Polygon: 'Polygon'
} as const;
export type PolygonTypeEnum = typeof PolygonTypeEnum[keyof typeof PolygonTypeEnum];


/**
 * Check if a given object implements the Polygon interface.
 */
export function instanceOfPolygon(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PolygonFromJSON(json: any): Polygon {
    return PolygonFromJSONTyped(json, false);
}

export function PolygonFromJSONTyped(json: any, ignoreDiscriminator: boolean): Polygon {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'extensions': !exists(json, 'extensions') ? undefined : json['extensions'],
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function PolygonToJSON(value?: Polygon | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'extensions': value.extensions,
        'coordinates': value.coordinates,
        'type': value.type,
    };
}

